import React, { type FC } from 'react'

import { useIntl } from 'react-intl'
import { useRecoilCallback, useRecoilValue } from 'recoil'

import {
  FormElement,
  INPUT_TEXT_VARIANT_DANGER,
  InputText,
} from 'mailup-web-components'

import {
  modalBulkFindReplaceChangeCallback,
  modalBulkFindReplaceFetchPreviewCallback,
} from 'Pages/RecipientsList/recoil/callbacks/modalBulkFindReplace'
import {
  modalBulkFindReplaceReplaceTextValidState,
  modalBulkFindReplaceState,
} from 'Pages/RecipientsList/recoil/state/modalBulkFindReplace'

const InputReplace: FC = () => {
  const intl = useIntl()

  const { ReplaceText, isReplaceTextDirty, previewStatus } = useRecoilValue(
    modalBulkFindReplaceState,
  )

  const isValid = useRecoilValue(modalBulkFindReplaceReplaceTextValidState)

  const change = useRecoilCallback(modalBulkFindReplaceChangeCallback, [])

  const fetchPreview = useRecoilCallback(
    modalBulkFindReplaceFetchPreviewCallback,
    [],
  )

  const handleChange = ({
    target: { value },
  }: React.ChangeEvent<HTMLInputElement>): void => {
    void change({ ReplaceText: value, isReplaceTextDirty: true })
  }

  const handleBlur = (e: React.FocusEvent<HTMLInputElement>): void => {
    void fetchPreview()
  }

  const hasFeedback = !isValid && isReplaceTextDirty

  const feedback = hasFeedback
    ? intl.formatMessage({ id: 'Load.MailupCommon.Required' })
    : undefined

  const feedbackVariant = hasFeedback ? 'error' : undefined

  const inputVariant = hasFeedback ? INPUT_TEXT_VARIANT_DANGER : undefined

  return (
    <FormElement
      label={intl.formatMessage({
        id: 'Load.RecipientsList.ModalBulkFindReplaceReplaceWith',
      })}
      feedback={feedback}
      feedbackVariant={feedbackVariant}
    >
      <InputText
        data-mu-test="find-replace-input-replace-text"
        value={ReplaceText}
        onChange={handleChange}
        onBlur={handleBlur}
        variant={inputVariant}
        placeholder={intl.formatMessage({
          id: 'Load.RecipientsList.ModalBulkFindReplaceReplaceWithPlaceholder',
        })}
        disabled={previewStatus === 'fetching'}
        maxLength={200}
      />
    </FormElement>
  )
}

export default InputReplace
